import { Paper, Stack } from "@mui/material";
import { ListRowSkeleton } from "./ListRowSkeleton";

export function ListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <Paper
      variant="outlined"
      data-testid="list-skeleton"
      role="status"
      aria-label="Loading"
    >
      <Stack divider={null}>
        {Array.from({ length: rows }, (_, index) => (
          <ListRowSkeleton key={index} />
        ))}
      </Stack>
    </Paper>
  );
}
